import { createProgram } from '../src/cli/program.js';

const program = createProgram();
program.parse(process.argv);
